import React from 'react'

const FProducts = () => {
  return (
    <div className='footer-column-container'>
      <div className='footer-container-1 footer-heading'>
        <h3>PRODUCTS</h3>
      </div>
      <div className='footer-container-1'>
        <p>Teams</p>
      </div>
      <div className='footer-container-1'>
        <p>Advertising</p>
      </div>
      <div className='footer-container-1'>
        <p>Collectives</p>
      </div>
      <div className='footer-container-1'>
        <p>Talent</p>
      </div>
    </div>
  )
}

export default FProducts